var _circle, _circle2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPyqSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4861,
    cy: 44,
    r: 28,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5701,
    cy: 41.0834,
    r: 8.75,
    fill: "#BDCBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2715 47.5616C34.7021 45.8279 35.6056 43.6042 35.6056 41.1544C35.6056 35.6517 31.1255 31.1666 25.6289 31.1666C20.1322 31.1666 15.6521 35.6517 15.6521 41.1544C15.6521 46.6571 20.1322 51.1422 25.6289 51.1422C28.0384 51.1422 30.2973 50.2753 32.0291 48.8054L39.7846 56.5695C39.9728 56.7579 40.1987 56.8333 40.4246 56.8333C40.6505 56.8333 40.8764 56.7579 41.0646 56.5695C41.4035 56.2303 41.4035 55.6272 41.0646 55.288L33.2715 47.5616ZM25.5912 49.333C21.0734 49.333 17.4216 45.6771 17.4216 41.1544C17.4216 36.6316 21.0734 32.9757 25.5912 32.9757C30.109 32.9757 33.7609 36.6316 33.7609 41.1544C33.7609 45.6771 30.109 49.333 25.5912 49.333Z",
    fill: "#6374FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5724 5.78625L52.4035 17.4717",
    stroke: "#6374FA",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5139 25.3485L56.4898 27.2067",
    stroke: "#6374FA",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.486 2L40.4862 12.3289",
    stroke: "#6374FA",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyqSearch);
export default __webpack_public_path__ + "static/media/PYQSearch.12678fd7d28d5706c2310753ab4b1a80.svg";
export { ForwardRef as ReactComponent };